// Common utils

import { Cache } from 'aws-amplify'

// Get cookie value by name
export const getCookie = (name: string): string | null => {
  if (!name) return null
  try {
    const cookies = document.cookie.split(';')
    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.trim().split('=')
      if (cookieName === name) {
        return cookieValue || ''
      }
    }
    return ''
  } catch (_err) {
    return ''
  }
}

// Join dog names
export const getDogNames = (dogs: any) => {
  if (!(dogs?.length > 0)) return
  const dogName = dogs
    .filter(d => d.name)
    .map(d => d.name)
    .join(', ')
    .replace(/,(?!.*,)/gim, ' &')
  if (!dogName) return
  Cache.setItem('dogName', dogName)
  return dogName
}

export const calculateAgeInMonths = (dob: string): number => {
  const dateToday = new Date()
  const dateDob = new Date(dob)
  const oneMonth = 1000 * 60 * 60 * 24 * (365 / 12)
  const diffInTime = dateToday.getTime() - dateDob.getTime()
  let ageInMonths = Math.round(diffInTime / oneMonth)
  if (ageInMonths < 0) ageInMonths = 0
  return ageInMonths
}

export const getDogAgeType = (ageInMonths: number): string => {
  if (ageInMonths <= 12) return 'puppy'
  if (ageInMonths < 96) return 'adult'
  return 'senior'
}

// Gtags
export const triggerTagging = (eventName: string, page: string, value?: any) => {
  if (typeof window.gtag !== 'undefined') {
    if (value) {
      window.gtag('event', eventName, {
        page: page,
        value: value
      })
    }
    window.gtag('event', eventName, {
      page: page
    })
  }
}
